import { createReducer } from 'reduxsauce';
import { Types } from './actions';

const INITIAL_STATE = {
  loading: false,
  singleT3: [],
  relatedArticles: [],
  tagsList: [],
  topPicks: null,
  bestSoftwares: null,
  error: null
};

// ************************* Fetch Single News *************************
const fetchSingleT3Start = (state = INITIAL_STATE, action) => {
  return { ...state, loading: true };
};

const fetchSingleT3Success = (state = INITIAL_STATE, action) => {
  let newSingleT3Arr;
  if (action.singleT3.postSlug !== null) {
    newSingleT3Arr = [...action.singleT3.singleT3];
  } else {
    newSingleT3Arr = [...state.singleT3, ...action.singleT3.singleT3];
  }
  return { ...state, singleT3: newSingleT3Arr, loading: false };
};

const fetchSingleT3Failure = (state = INITIAL_STATE, action) => {
  return { ...state, loading: false, error: action.error };
};
// _____________________________________________________________________

// ************************** Fetch Top Picks ***************************
const fetchTopPicksStart = (state = INITIAL_STATE, action) => {
  return { ...state, loading: true };
};

const fetchTopPicksSuccess = (state = INITIAL_STATE, action) => {
  return { ...state, topPicks: action.topPicks, loading: false };
};

const fetchTopPicksFailure = (state = INITIAL_STATE, action) => {
  return { ...state, loading: false };
};
// _____________________________________________________________________

// ************************* Fetch Related Articles *************************
const fetchRelatedArticlesForSingleT3Start = (
  state = INITIAL_STATE,
  action
) => {
  return { ...state, loading: true };
};

const fetchRelatedArticlesForSingleT3Success = (
  state = INITIAL_STATE,
  action
) => {
  let newRelatedArticles, newTagList;
  // console.log('********* *********', state.singleNews);
  // console.log('********* *********', state.singleNews.length);
  // if (action.relatedArticles.length === 0) {
  //   newRelatedArticles = [...state.relatedArticles, []];
  // } else {
  newRelatedArticles = [
    // ...state.relatedArticles, [
    ...action.relatedArticles.relatedArticles
    // ]
  ];
  newTagList = [
    // ...state.tagsList,
    ...action.relatedArticles.tagsList
  ];
  // }
  return {
    ...state,
    relatedArticles: newRelatedArticles,
    tagsList: newTagList,
    loading: false
  };
};

const fetchRelatedArticlesForSingleT3Failure = (
  state = INITIAL_STATE,
  action
) => {
  return { ...state, loading: false };
};
// _____________________________________________________________________

// ************************** Fetch Best Softwares ***************************
const fetchBestSoftwaresStart = (state = INITIAL_STATE, action) => {
  return { ...state, loading: true };
};

const fetchBestSoftwaresSuccess = (state = INITIAL_STATE, action) => {
  return { ...state, bestSoftwares: action.bestSoftwares, loading: false };
};

const fetchBestSoftwaresFailure = (state = INITIAL_STATE, action) => {
  return { ...state, loading: false };
};
// _____________________________________________________________________

// Define Handlers
const HANDLERS = {
  [Types.FETCH_SINGLE_T3_START]: fetchSingleT3Start,
  [Types.FETCH_SINGLE_T3_FAILURE]: fetchSingleT3Failure,
  [Types.FETCH_SINGLE_T3_SUCCESS]: fetchSingleT3Success,

  [Types.FETCH_TOP_PICKS_START]: fetchTopPicksStart,
  [Types.FETCH_TOP_PICKS_FAILURE]: fetchTopPicksFailure,
  [Types.FETCH_TOP_PICKS_SUCCESS]: fetchTopPicksSuccess,

  [Types.FETCH_RELATED_ARTICLES_FOR_SINGLE_T3_START]: fetchRelatedArticlesForSingleT3Start,
  [Types.FETCH_RELATED_ARTICLES_FOR_SINGLE_T3_FAILURE]: fetchRelatedArticlesForSingleT3Failure,
  [Types.FETCH_RELATED_ARTICLES_FOR_SINGLE_T3_SUCCESS]: fetchRelatedArticlesForSingleT3Success,

  [Types.FETCH_BEST_SOFTWARES_START]: fetchBestSoftwaresStart,
  [Types.FETCH_BEST_SOFTWARES_FAILURE]: fetchBestSoftwaresFailure,
  [Types.FETCH_BEST_SOFTWARES_SUCCESS]: fetchBestSoftwaresSuccess
};

// Create and Export Reducer
export const singleT3Reducer = createReducer(INITIAL_STATE, HANDLERS);
